import React from 'react'
import { useGlobalState } from '../../../../../hooks/store/useGlobalState'
import { Organization as FHIROrganization } from '@teschglobal/tg-fhir-react-components/dist/types'
import { Organization } from '@teschglobal/tg-fhir-react-components'

type OrganizationDetailProps = {
    resource: FHIROrganization | null
    isFetching: boolean
}


const OrganizationDetail: React.FC<OrganizationDetailProps> = ({ resource }) => {
    const organizationFromState = useGlobalState(state => state.organization)
    
    const resolvedResource = resource ?? organizationFromState ?? undefined

    return (
        <section>
            <h3>Organization</h3>
            <Organization data={resolvedResource} />
        </section>
    )
}

export default OrganizationDetail